export default __webpack_public_path__ + "static/media/partner_img_04.6a90f7a8.svg";